import { AccountModule } from './helpers/account-helper'

const module = AccountModule({
	name: 'typeform',
	retrieveUrl: (companyId) => `api/company/${companyId}/typeform-account/`,
	removeUrl: (companyId, accountId) => `api/company/${companyId}/typeform-account/${accountId}/`,
	createUrl: (companyId) => `api/company/${companyId}/typeform-account/`,
})

module.actions.oauthUrl = async function (_, { companyId }) {
	return await useNuxtApp().$api(`api/company/${companyId}/typeform-account/oauth-url/`)
}

export default module
